import { useMemo } from 'react'
import { submitNote } from 'utils/actions/notes'
import { SHIPMENT_UPDATE_ACTION_TYPES } from 'utils/actions/shipments'
import { getUserDetails } from 'utils/hooks/useUserDetails'
import { getEligibleTime, getMinutes } from 'utils/accessorialHelpers'
import { generateBaseUrl } from 'utils/generateAppDefaults'
import { isUserType } from 'utils/userTypes'

export const detention = store => next => async action => {
  const {
    shipmentData: { shipment: { stops, info: { opsRepName, shipperOpsRepName } = {} } = {} },
  } = store.getState()

  if (action.type === SHIPMENT_UPDATE_ACTION_TYPES.SHIPMENT_UPDATE_SUCCESS) {
    const { id: userId = '', userType = '' } = getUserDetails() || {}
    const isAdmin = isUserType('admin', userType)
    const { id, pathName: accessorialPathId } = action.payload.requestData
    if (isAdmin && !accessorialPathId) {
      const { accessorials } = action.payload.shipment
      const accessorialId = accessorials[accessorials.length - 1]?.id
      const createdAccessorial = accessorials.find(a => a.id === accessorialId)
      const { amount, destinationTitle, endAt, shipperFacilityUuid, startAt, state } =
        createdAccessorial || {}

      const detailsUrl = generateBaseUrl(`detention-review/edit/${id}/${accessorialId}`)

      if (state === 'approved') {
        const createNotesTag = repName => {
          if (repName) {
            const formatRepName = repName.toLowerCase().replace(/\s/g, '')
            return `@${formatRepName}`
          }
          return ''
        }
        const tagOpsRep = createNotesTag(opsRepName)
        const tagShipperOpsRep = createNotesTag(shipperOpsRepName)
        const { appointment } =
          stops.find(stop => stop.facility.shipperFacilityUuid === shipperFacilityUuid) || {}
        const minutes = useMemo(
          () =>
            getMinutes({
              startDateTime: startAt,
              endDateTime: endAt,
              appointment,
            }),
          [startAt, endAt, appointment]
        )
        const eligibleTime = useMemo(() => getEligibleTime(minutes), [minutes])
        const hourlyRate = 50

        const body = `${tagShipperOpsRep} ${tagOpsRep} Detention approved at ${destinationTitle} for $${hourlyRate} x ${eligibleTime} = $${amount}`
        const note = {
          body,
          createdById: userId,
          noteableType: 'Shipment',
          noteableId: id,
        }
        await store.dispatch(submitNote(note))
      }

      global.location.replace(detailsUrl)
    } else if (!isAdmin) {
      const successUrl = generateBaseUrl(`detention-review/success/${id}`)
      global.location.replace(successUrl)
    } else {
      global.location.reload()
    }
  }
  return next(action)
}
